export const EMPTY_STRING_SEARCH_TOKEN = '""';
